import { __assign, __rest } from "tslib";
// DS6.1.2
import React from 'react';
import c from 'classnames';
import { ThemeOverride, ThemeOptions, } from '@wix/da-react-context/pkg/ThemeContext';
import s from './SelectionListCard.scss';
var SelectionListCard = function (_a) {
    var className = _a.className, children = _a.children, innerRef = _a.innerRef, props = __rest(_a, ["className", "children", "innerRef"]);
    return (React.createElement(ThemeOverride, { theme: ThemeOptions.LIGHT, className: c(s['root'], className) },
        React.createElement("div", __assign({ className: s['content'], ref: innerRef }, props), children)));
};
SelectionListCard.displayName = 'SelectionListCard';
export default SelectionListCard;
//# sourceMappingURL=SelectionListCard.js.map